<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <p class="mb-4">
        {{ $t('setting.cutOffAutomation.import.description') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end d-flex">
          <McButton
            variant="secondary"
            :text="$t('global.importResult.historyUpload')"
            icon="icon-outline_file-text"
            :class="{ 'mx-2': !importResponse }"
            @click="$bvModal.show('modal-import-history')"
          />
          <McButton
            v-if="importResponse"
            variant="primary"
            class="mx-2"
            icon="icon-outline_upload"
            :text="$t('global.importResult.uploadAgain')"
            @click="deleteFile"
          />
          <McButtonBack href="/setting/engine-off/" />
        </div>
      </div>
    </div>

    <b-card class="mc-card__setting">
      <b-tabs v-model="tabIndex" content-class="p-3 text-muted" @input="handleActivateTab">
        <NewData ref="newData" @update:importResponse="handleImportResponse" />
        <UpdateData ref="updateData" @update:importResponse="handleImportResponse" />
      </b-tabs>
    </b-card>

    <ImportHistory />
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McButtonBack from '@/components/McButtonBack'
import McButton from '@/components/McButton'
import NewData from './new'
import UpdateData from './update'
import ImportHistory from './ImportHistory'

export default {
  page: {
    title: 'Import Engine Off Automation',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    McButton,
    NewData,
    UpdateData,
    ImportHistory,
  },
  data() {
    return {
      tabIndex: 0,
      tabs: ['#new-data', '#update-data'],
      importResponse: false,
      currentImportType: null,
    }
  },
  computed: {
    title() {
      return this.$t('global.action.upload')
    },
    items() {
      return [
        {
          text: this.$t('setting.list.fleetGroup.setting'),
          to: '/setting',
        },
        {
          text: this.$t('setting.homePage.cutOffAutomation'),
          to: '/setting/engine-off',
        },
        {
          text: this.$t('global.action.upload'),
        },
      ]
    },
  },
  beforeMount() {
    const idx = this.tabs.findIndex((tab) => tab === this.$route.hash)
    if (idx !== -1) this.tabIndex = idx
  },
  methods: {
    handleActivateTab(newTabIndex) {
      this.$router.push(this.tabs[newTabIndex])
    },
    handleImportResponse(data) {
      this.importResponse = data.status
      this.currentImportType = data.type
    },
    deleteFile() {
      this.importResponse = false
      if (this.currentImportType === 'new') {
        this.$refs.newData.deleteFile()
      } else {
        this.$refs.updateData.deleteFile()
      }
    },
  },
}
</script>
